// A row counts as verified (Проверил) only when the SAVED row carries the server stamp.
// `verifyRequested` alone is a pending client flag, never a verification.
export const isRowVerified = (row: { verifiedBy?: unknown; verifiedAt?: string; verifiedByName?: string }): boolean =>
  !!(row.verifiedBy || row.verifiedAt || row.verifiedByName);
